<template>

  <div class="stepper-range">
    <input ref="startInput"
           v-model:value="min"
           type="number"
           pattern="\d*"
           :min="range.min"
           :max="range.max"
           @keyup="handleEvent"
           step="1">
    <span class="stepper-range__divider">to:</span>
    <input ref="endInput"
           v-model:value="max"
           type="number"
           pattern="\d*"
           :min="range.min"
           :max="range.max"
           @keyup="handleEvent"
           step="1">
    <popover-checkmark-btn @click.native="handleClick" :disabled="incorrectValue"/>
  </div>

</template>

<script>
import PopoverCheckmarkBtn from './PopoverCheckmarkBtn'

export default {
  components: {
    PopoverCheckmarkBtn
  },
  props: {
    attribute: Object
  },
  data () {
    return {
      min: this.attribute.value ? this.attribute.value.min : this.attribute.min,
      max: this.attribute.value ? this.attribute.value.max : this.attribute.max,
      range: {
        min: this.attribute.min,
        max: this.attribute.max
      }
    }
  },
  computed: {
    incorrectValue () {
      return Number(this.min) > Number(this.max) || Number(this.max) < Number(this.min) || Number(this.min) < Number(this.range.min) || Number(this.max) > Number(this.range.max)
    }
  },
  methods: {
    handleClick () {
      const newValue = {
        min: Number(this.min),
        max: Number(this.max)
      }
      this.$emit('select', newValue)
    },
    handleEvent (e) {
      // this is to prevent shortcuts from changing
      // definition while popover is open.
      e.stopPropagation()
    }
  }
}
</script>

<style lang="scss">

.stepper-range {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: auto;
  padding: 4px 8px;

  input {
    width: 80px;
    height: 30px;
    text-align: center;
    border-radius: 3px;
    border: 1px solid color(grays, dark);
    background: color(blue-grey, dark);
    color: white;
  }

  &__divider {
    padding: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// StepperRange.vue?660bac40